export function formatNumber(value) {
  if (isNaN(value)) return value; // Return if not a number
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}
